import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAppSelector } from "../../app/hooks";
import { selectUser } from "../../app/features/usersSlice";

export const userRoles = {
  superAdmin: "super-admin",
  admin: "admin",
};

export function Authentication(Element, allowedRoles) {
  const user = useAppSelector(selectUser);

  let content = <Outlet />;

  if (user && allowedRoles.includes(user[0]?.role)) {
    content = <Element />;
  } else {
    content = <Navigate to="/login" />;
  }

  return content;
}
